import React from "react";
import {Route} from "react-router-dom";
import {Content} from "./Content";

export function ContentRoute({ children, component, render, webview, ...props }) {
  return (
    <Route {...props}>
      {routeProps => {
        if (typeof children === "function") {
          return <Content webview={webview}>{children(routeProps)}</Content>;
        }

        if (!routeProps.match) {
          return null;
        }

        if (children) {
          return <Content webview={webview}>{children}</Content>;
        }

        if (component) {
          return (
            <Content webview={webview}>{React.createElement(component, routeProps)}</Content>
          );
        }

        if (render) {
          return <Content webview={webview}>{render(routeProps)}</Content>;
        }

        return null;
      }}
    </Route>
  );
}
